import { useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import logo from "../../images/logo/white-ontrack-logo.jpeg";
import CustomButton from "../customButtom/CustomButton";
import DownloadIcon from "../../images/svgs/DownloadIcon";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const Invoice = () => {
  const invoiceRef = useRef(null);
  const location = useLocation();
  const [hideDownloadButton, setHideDownloadButton] = useState(false);
  const currentDate = new Date().toLocaleDateString("en-US");

  const appointment = location.state?.appointment;
  const { firstName, lastName } = useSelector((state) => state.auth);

  if (!appointment) {
    return <div className="text-red-500">No appointment details found.</div>;
  }

  // Extract fees and ensure default values if missing
  const consultingFee = appointment?.details?.consultingFee || 0;

  // Calculate subtotal and total
  const subTotal = consultingFee;
  const totalAmount = subTotal; // Add taxes/discounts if needed

  const handleDownload = async () => {
    setHideDownloadButton(true);

    setTimeout(async () => {
      const invoiceElement = invoiceRef.current;
      const canvas = await html2canvas(invoiceElement, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save("invoice.pdf");

      setHideDownloadButton(false);
    }, 300);
  };

  return (
    <div ref={invoiceRef} className="bg-white shadow-lg p-6 md:p-8 rounded-lg">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-6">
        <div className="flex items-center space-x-2">
          <img src={logo} alt="Edmate Logo" className="w-48 md:w-64 h-auto" />
        </div>
        <div className="text-sm text-gray-600 mt-4 md:mt-0">
          <p>
            <strong>Order:</strong> {appointment?.details?.meetingId || "N/A"}
          </p>
          <p>
            <strong>Issued: </strong>
            {currentDate}
          </p>
        </div>
      </div>

      {/* Invoice To */}
      <div className="mb-6">
        <h2 className="text-lg font-semibold">Invoice To</h2>
        <p className="text-gray-700">{`${firstName} ${lastName}` || "N/A"}</p>
      </div>

      {/* Payment Method */}
      <div className="mb-6">
        <h2 className="text-lg font-semibold">Payment Method</h2>
        <p className="text-gray-700">Stripe Payment</p>
      </div>

      {/* Table */}
      <div className="border overflow-hidden mb-6">
        <table className="w-full text-left border-collapse text-sm md:text-base">
          <thead>
            <tr className="bg-gray-100 text-gray-700">
              <th className="p-2 md:p-3">DESCRIPTION</th>
              <th className="p-2 md:p-3">TIME</th>
              <th className="p-2 md:p-3">STATUS</th>
              <th className="p-2 md:p-3">TOTAL</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-t">
              <td className="p-2 md:p-3">Mentor Fee</td>
              <td className="p-2 md:p-3">
                {appointment?.details?.duration || 0} Min
              </td>
              <td className="p-2 md:p-3">Paid</td>
              <td className="p-2 md:p-3">${consultingFee.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Summary */}
      <div className="text-right mb-6 flex flex-col items-end gap-2.5">
        <p>
          <strong>Subtotal:</strong> ${subTotal.toFixed(2)}
        </p>
        <hr className="border border-gray-300 w-64" />
        <p className="text-xl font-semibold">
          <strong>Total Amount:</strong> ${totalAmount.toFixed(2)}
        </p>
      </div>

      {/* Other Information */}
      {/* <div className="text-gray-600 text-sm mb-6">
        <h2 className="text-lg font-semibold">Other Information</h2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus sed
          dictum ligula, cursus blandit risus. Maecenas eget metus non tellus
          dignissim aliquam ut a ex.
        </p>
      </div> */}

      {/* Download Button (conditionally hidden) */}
      {!hideDownloadButton && (
        <div className="flex justify-end">
          <CustomButton
            label={"Download Report"}
            buttonClass="bg-custom-blue px-5 flex items-center py-3 rounded-md"
            leftIcon={<DownloadIcon />}
            onClick={handleDownload}
          />
        </div>
      )}
    </div>
  );
};

export default Invoice;
